import React , { useState,useEffect } from 'react';
import { Link } from 'react-router-dom';


function Random(){
    const[rnd,uprnd]=useState([]);
    

    const GetRnd=async()=>{
        const res= await fetch('https://www.themealdb.com/api/json/v1/1/random.php');
        const realdata=await res.json();
        uprnd(realdata.meals[0])
        
    }
    useEffect(()=>{
        GetRnd();
    },[])

    return(
        <>
           <Link to={`/search/${rnd.idMeal}`} className='linkrandom'>
 
        <div className='resdiv'>
         <img src={rnd.strMealThumb}  className='imgresult' />
            <h5>{rnd.strMeal}</h5>
            </div>
           </Link>
        </>
    )
}

export default Random;